export const setNurseOptions = ({ columns, data }) => {
  const nurseAccessor = columns.findIndex((c) => c.accessor === 'nurse');

  data.forEach((d) => {
    const nurseIndex = columns[nurseAccessor].options.findIndex(
      (x) => x.id === d.id,
    );

    if (nurseIndex === -1)
      columns[nurseAccessor].options.push({
        id: d.id,
        value: d.id,
        label: `${d.firstName} ${d.lastName}`,
        firstName: d.firstName,
        lastName: d.lastName,
        selected: true,
      });
  });

  return { columns, nurseOptions: columns[nurseAccessor].options };
};
